import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { CART_ENDPOINTS } from '@/rtkQuery/config/cartApi.config';
import { buildQuery } from '@/rtkQuery/lib';
import type { CartResponse } from '@/rtkQuery/features/models/cart.model';

const cartApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCart: builder.query<CartResponse, void>({
            query: buildQuery(CART_ENDPOINTS.GET_CART, 'GET'),
            transformResponse: (response: CartResponse, meta) => {
                (meta as any).status = 'success';
                (meta as any).error = null;
                return response;
            },
            transformErrorResponse: (response: any, meta) => {
                const errorMessage = response?.message || response.data?.message || 'Failed to fetch cart';
                (meta as any).status = 'error';
                (meta as any).error = errorMessage;

                return {
                    status: response.status,
                    message: errorMessage,
                    errors: response.data?.errors || {},
                };
            },
            providesTags: ['Cart'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetCartQuery,
    useLazyGetCartQuery
} = cartApi;
